<template>
    <el-dialog title="联系地址" :visible.sync="centerDialogVisible" width="600px" class="relationAddress">
        <div class="inputBox">
            <p class="title">联系地址</p>
            <el-input v-model="relationAddress" type="textarea" resize="none" placeholder="请输入联系地址" maxlength="30" show-word-limit></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import {updateShopSet} from 'api/accountApi'
export default {
    name: 'relationAddress',
    data() {
        return {
            centerDialogVisible: false,
            relationAddress: ''
        }
    },
    props: ['data'],
    methods: {
        close() {
            this.centerDialogVisible = false
        },
        confirm() {
            if (this.relationAddress) {
                this.setLoading(true)
                updateShopSet({
                    data: {linkaddress: this.relationAddress},
                    success: data => {
                        this.setLoading(false)
                        this.centerDialogVisible = false
                        this.$message.success('设置成功')
                        this.$emit('getMsg')
                    },
                    error: data => {
                        this.setLoading(false)

                    }
                })
            } else {
                this.$message.error('请输入联系地址')
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        'data': {
            handler(newV) {
                if (newV) {
                    this.relationAddress = newV.linkaddress
                }
            }
        },
        deep: true
    }
}
</script>
<style lang="scss">
    .relationAddress{
        .inputBox{
            display: flex;
            .title{
                margin: 10px 40px 0 16px;
            }
            .el-textarea{
                width: 433px;
                .el-textarea__inner{
                    height: 98px;
                }
            }
        }
    }
</style>